import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/maintenance/page.tsx");
